import { reduce, mergeRight } from "ramda";

// makes a list of objects as map with specified identifier
// identifier should be unique
const groupByProp = id =>
  reduce((acc, v) => (v ? mergeRight(acc, { [v[id]]: v }) : acc), {});

export default groupByProp;
